/* Cart surcharge sync — keeps Custom Design line items in sync with parent product qty */
(function(){
  if(!/\/cart/.test(location.pathname))return;

  /* Prevent infinite reload: max 1 sync-reload per 10 seconds */
  var SYNC_KEY='_scs';
  var lastSync=parseInt(sessionStorage.getItem(SYNC_KEY)||'0');
  if(Date.now()-lastSync<10000)return hideControls();

  var syncing=false;

  function syncCart(){
    if(syncing)return;
    syncing=true;
    fetch('/cart.js',{credentials:'same-origin'})
    .then(function(r){return r.json();})
    .then(function(cart){
      var parentQty={};
      var surcharges=[];

      cart.items.forEach(function(item){
        var p=item.properties||{};
        if(p._src==='surcharge'&&p._link){
          surcharges.push(item);
        }else if(p._link){
          parentQty[p._link]=(parentQty[p._link]||0)+item.quantity;
        }
      });

      var updates={};
      surcharges.forEach(function(item){
        var expected=parentQty[item.properties._link]||0;
        if(item.quantity!==expected){
          updates[item.key]=expected;
        }
      });

      if(Object.keys(updates).length>0){
        sessionStorage.setItem(SYNC_KEY,String(Date.now()));
        /* Use Shopify section rendering to avoid full page reload */
        var sectionId=document.querySelector('cart-items')&&document.querySelector('cart-items').dataset.sectionId;
        var url='/cart/update.js';
        var body={updates:updates};
        if(sectionId)body.sections=[sectionId];

        fetch(url,{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify(body)
        })
        .then(function(r){return r.json();})
        .then(function(data){
          syncing=false;
          if(data.sections&&sectionId&&data.sections[sectionId]){
            /* Replace cart section HTML without full reload */
            var parser=new DOMParser();
            var doc=parser.parseFromString(data.sections[sectionId],'text/html');
            var newCart=doc.querySelector('cart-items')||doc.querySelector('.cart__items');
            var oldCart=document.querySelector('cart-items')||document.querySelector('.cart__items');
            if(newCart&&oldCart){
              oldCart.innerHTML=newCart.innerHTML;
              /* Update totals too */
              var newTotals=doc.querySelector('.cart__totals, .totals');
              var oldTotals=document.querySelector('.cart__totals, .totals');
              if(newTotals&&oldTotals)oldTotals.innerHTML=newTotals.innerHTML;
              /* Update cart count in header */
              var newCount=doc.querySelector('.cart-count-bubble, [data-cart-count]');
              if(newCount){
                document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(function(el){
                  el.innerHTML=newCount.innerHTML;
                });
              }
            }else{
              /* Fallback: full reload if can't find sections */
              location.reload();
              return;
            }
            hideControls();
          }else{
            /* No section rendering — fallback reload */
            location.reload();
          }
        })
        .catch(function(){syncing=false;});
      }else{
        syncing=false;
        hideControls();
      }
    }).catch(function(){syncing=false;});
  }

  function hideControls(){
    document.querySelectorAll('tr.cart-item, .cart-item').forEach(function(row){
      var titleEl=row.querySelector('.cart__item-title, [class*="cart-item__name"], a[href*="/products/custom-"]');
      if(!titleEl)return;
      var text=titleEl.textContent||'';
      if(text.indexOf('Custom Design')===-1)return;
      /* Hide qty controls */
      var qtyWrap=row.querySelector('quantity-input, .cart-quantity');
      if(qtyWrap)qtyWrap.style.cssText='visibility:hidden;height:0;overflow:hidden';
      /* Hide remove link */
      var removeBtn=row.querySelector('[is="cart-remove-button"], a[href*="cart/change"]');
      if(removeBtn)removeBtn.style.display='none';
      /* Add "synced" label */
      var cell=row.querySelector('.cart-item__quantity, td:nth-child(2)');
      if(cell&&!cell.querySelector('.surcharge-label')){
        var lbl=document.createElement('span');
        lbl.className='surcharge-label';
        lbl.style.cssText='font-size:.7rem;color:#6b6560;font-style:italic';
        lbl.textContent='Engraving fee \u2014 synced with product qty';
        cell.prepend(lbl);
      }
    });
  }

  /* Initial sync on page load */
  syncCart();

  /* Re-sync after AJAX cart updates (Dawn theme uses fetch to /cart/change) */
  var _fetch=window.fetch;
  window.fetch=function(){
    var result=_fetch.apply(this,arguments);
    var url=arguments[0];
    if(typeof url==='string'&&/\/cart\/(change|update)/.test(url)&&!syncing){
      result.then(function(){setTimeout(syncCart,600);});
    }
    return result;
  };
})();
